import { useContext } from 'react';
import { createEditingTableContext, EditingContextValue } from '../context/EditableTableContex';

export const EditableTableContext = createEditingTableContext<any>();

export const useEditableTableContext = <T extends Record<string, any>>() =>
	useContext(EditableTableContext as React.Context<EditingContextValue<T>>);
